export default {
  name: 'marketing',
  component: () =>
    import(
       /* webpackChunkName: "Auth Layout" */ '@/modules/admin/layouts/AuthLayout.vue'
    ),
  children: [
    {
      path: 'estados-cuenta',
      name: 'homeMarketing',
      meta: { title: 'Estados de Cuenta' },
      component: () =>
        import(
          /* webpackChunkName: "Credit Clients View" */ '@/modules/marketing/views/credit/CreditClientsView.vue'
        ),
    },
    {
      path: 'historial-pagos',
      name: 'historyPayments',
      meta: { title: 'Historial de Pagos' },
      component: () =>
        import(
          /* webpackChunkName: "Login View" */ '@/modules/marketing/views/historical/HistoricalPayments.vue'
        ),
    },
    {
      path: 'facturas-contado',
      name: 'cashBillingMarketing',
      meta: { title: 'Facturas contado' },
      component: () =>
        import(
          /* webpackChunkName: "Cash Billing View" */ '@/modules/shared/cashBilling/views/CashBillingView.vue'
        ),
    },
    {
      path: ':pathMatch(.*)*',
      redirect: {
        name: 'homeMarketing',
      },
    },
  ],
};
